<template>
  <div class="content">
    <div class="content-header">
      <div
        v-if="item.brand && item.brand !== 'unknown'"
        class="product-brand"
      >
        {{ item.brand }}
      </div>
      <div class="title">
        <h3 class="product-title">
          <router-link
            :to="path"
            tag="a"
            class="product-title-link"
          >
            {{ item.title }}
          </router-link>
        </h3>
      </div>
      <div class="product-subtitle">
        <!-- needs to be re-enabled -->
        <!-- {{ item.subtitle }} {{ vintageDisplay.value }} -->
      </div>
    </div>

    <div class="content-lower">
      <div class="pricing-region simple-display">
        <div
          v-if="packPricingEnabled"
          class="pack-item-element"
        >
          <div class="pack-item">
            <div class="price-value">
              <PriceElement
                :price="packPrice"
              />
              <div class="label-divider">
                /
              </div>
              <div class="price-label">
                {{ packPriceLabel }}
              </div>
            </div>
          </div>
        </div>

        <div class="price-item">
          <div
            title="Per Bottle"
            class="price-value"
          >
            <PriceElement
              v-if="displayRRP"
              :price="rrpPrice"
              prepend="$"
              class="rrp"
            />
            <PriceElement
              v-else-if="displayBasePrice"
              :price="basePrice"
              prepend="$"
              class="rrp"
            />
            <PriceElement
              :price="sellPrice"
              prepend="$"
              class="sale-price"
            />
          </div>
        </div>
      </div>

      <div class="card-actions">
        <HighlightButton
          :disabled="outOfStock"
          :class="stockManagedClass"
          :title="stockManagedText"
          button-type="pill"
          button-style="solid"
          button-size="small"
          button
          @clicked="addToCartLinkClicked"
        />
      </div>
      <div
        v-if="item.region && item.region !== 'unknown'"
        class="product-region"
      >
        {{ item.region }}
      </div>
    </div>
  </div>
</template>

<script>
// mixins
import carouselProductMixin from '../../mixins/carouselProductMixin'
import CartAddBlock from '@aspedia/vuejs-ecommerce-ui/components/cart-add-block/0002/cart-add-block'
import purchaseMixin from '@aspedia/vuejs-ecommerce-ui/mixins/item-purchase-qty.js'
import generalutils from '@aspedia/vuejs-ecommerce-ui/mixins/general-utils.js'
import PriceElement from '../PriceElement.vue'

export default {
  name: 'carousel-product-grid-content',
  components: {
    PriceElement,
    CartAddBlock
  },
  mixins: [carouselProductMixin, purchaseMixin, generalutils]
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.product-title {
    font-size:var(--product-title-font-size);
    line-height:var(--product-title-line-height);
    //MS edgages
    word-break: normal;
    word-break: break-word;
    text-overflow: ellipsis;
    overflow: hidden;
}

.product-title-link {
  color:var(--vc-link-color);
}

.product-subtitle {
    font-size:var(--product-subtitle-font-size);
    font-style:italic;
}

.pricing-region {
    display:flex;
    justify-content: center;
    align-items: flex-end;
    flex-wrap: wrap;

    width: 100%;
    margin: 1em 0em;
    .rrp {
        text-decoration: line-through;
        font-size:.65em;
    }
    .price-value {
        font-size:1.15em;
    }
    .price-label {
        font-size:.75em;
    }
    .price-item {
        justify-content: center;
          &:not(:last-child){
            border-right:1px solid;
            border-color:var(--vc-border-color);
          }
          &:not(:first-child),
          &:not(:last-child) {
            width: calc(50% - .5em);
            padding: 0em 0.5em;
          }
          &:only-child {
              width:100%;
          }
    }
}

.pricing-region{
    &.pack-display {
        display: none;
    }
    &.simple-display {
    .label-divider{
        margin:0em .5em;
    }
    .pack-item-element {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color:var(--product-pack-element-text-color);
    margin-bottom:1em;
    font-size: .8em;

        //left side
        &:before {
            margin-right:var(--product-pack-element-border-gap);
        }
        //right side
        &:after {
            margin-left:var(--product-pack-element-border-gap);
        }
        &:before, &:after {
        content: "";
        height: 1px;
        background:var(--product-pack-element-border-color);
        flex-grow: 1;
        }
        .price{
            font-size:1em;
        }
        .price-label {
            font-size:1em;
        }
    }
    .price-item {
        display:flex;
    }
    .price-value {
        display: flex;
        align-items: center;
    }
    .price {
        font-size:1.2em;
    &.rrp {
        text-decoration: line-through;
        font-size:.8em;
        margin-right:.75em;
    }
    }
    }
}
.product-price {
    display:flex;
    font-size:var(--product-price-font-size);
    font-family:var(--vc-heading-font);
}
.card-actions {
    align-content: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin:0em auto;
}

::v-deep  .sold-out {
    cursor: default;
    opacity: .5;
}

::v-deep  .product-link {
  cursor: pointer;
}

.content-header {
    display: flex;
    flex-direction: column;
}
.content-lower {
    display: flex;
    flex-grow: 1;
    align-items: center;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
}

.content {
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding:var(--product-card-content-padding);
  font-size:calc(var(--product-card-content-font-size) * .8);
  color:var(--product-card-text-color);

  @include media-breakpoint-up(sm) {
    font-size:var(--product-card-content-font-size);
  }
}

//percent badge position

.percent-badge {
    position: absolute;
    top: 1em;
    left: 1em;
}

.low-stock-badge{
  position: absolute;
  top:1em;
  right:1em;
}

.product-link {
  cursor: pointer;
}
</style>
